define((require) => {
    "use strict";

    var $                                   = require("jquery"),
        {
            isEmpty, isString, keys, each
        }     = require("underscore"),
        CustomJsAction                      = require("shared/ui/experience/action/customJs/CustomJsAction"),
        CustomJsLockIconView                = require("editor/ui/settings/integrations/customJs/lockIcon/CustomJsLockIconView"),
        EditBehavior                        = require("ui/behaviors/EditBehavior"),
        EditorEvents                        = require("shared/services/EditorEvents"),
        helpers                             = require("editor/ui/settings/integrations/customJs/editCustomJs/EditCustomJsViewHelpers"),
        ImprovedView                        = require("editor/zbone/ImprovedView"),
        LoggedInUserState                   = require("shared/ui/user/LoggedInUserState"),
        Permissions                         = require("shared/security/Permissions"),
        SequentialButton                    = require("util/SequentialButton"),
        {isBlank}                           = require("shared/util/StringUtils"),
        template                            = require("editor/ui/settings/integrations/customJs/editCustomJs/EditCustomJsView.tpl"),
        ValidateBehavior                    = require("ui/behaviors/ValidateBehavior");

    var CODE_WONT_RUN_MSG        = "The code is malformed",
        CODE_TITLE_HASNT_CHANGED = "Neither the code nor title has changed";

    return ImprovedView.extend("EditCustomJsView", {

        /**
         * @private @type {Boolean}
         * Is the code editable by this user
         */
        _readOnly: null,

        /**
         * @private {SequentialButton}
         * The sequential button representing the "Save" button in the ui.
         */
        _saveButton: null,

        /**
         * @private {Promise}
         * A deferred pending while a save is in progress.
         */
        _saveDeferred: null,

        template: template,

        templateHelpers: function() {
            return {
                readOnly: this._readOnly,
                code: this.model.get("action").get("code")
            };
        },

        className: "new-js-lightbox",

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,

                container: ".title-container",

                editFields: [{
                    input:   ".title",
                    tooltip: false // because size calculation is wrong/off, so tooltip always enabled otherwise! :/
                }]
            },

            validateBehavior: {
                behaviorClass: ValidateBehavior,

                buttonSubmit: function(enable) {
                    if (this._saveButton) {
                        this._saveButton.enable(enable);  // SequentialButton not created until render time!
                    }
                },

                inputValidation: {
                    ".title": {
                        validator: function(title) {
                            // Because of stick it, I think, this sometimes gives the jquery element, not the text
                            // value, when it is empty. So, only valid if a non-empty string...
                            return isString(title) && !isBlank(title);
                        },

                        errorText: "Title required",

                        tooltip: false
                    },
                    ".textarea": { // code!
                        validator: function(code) {
                            // isString check included for the same reason as above.
                            return isString(code) &&
                                 !isBlank(code) &&
                                 !this.model.get("actionIsInUse") &&
                                 !CustomJsAction.checkRunnableCode(code, helpers.findParameters(code));
                        },

                        errorText: CODE_WONT_RUN_MSG, // for log

                        tooltip: false
                    },
                    ".textarea, .title": {
                        validator: function() {
                            var newName = this.ui.title.html(),
                                newCode = this.ui.textarea.val(),
                                oldName = this.model.get("name"),
                                oldCode = this.model.get("code");

                            // We return true if something has changed.
                            return newName !== oldName || newCode !== oldCode;
                        },

                        errorText: CODE_TITLE_HASNT_CHANGED,

                        tooltip: false
                    }
                }
            }
        },

        ui: {
            title:            ".title",
            plus:             ".plus-icon",
            textarea:         ".textarea",
            codeErrorMessage: ".code-error-message",
            parameterList:    ".parameter-list",
            saveButton:       ".save-new-custom-js",
            cancelButton:     ".cancel-new-custom-js"
        },

        regions: {
            lockRegion: ".lock-region"
        },

        events: {
            "mouseup @ui.textarea":   "_handleSelectionStart",
            "keyup @ui.textarea":     "_textareaChangeHandler",
            "click @ui.plus":         "_handlePlusClick",
            "click @ui.saveButton":   "_saveAction",
            "click @ui.cancelButton": "closeView"
        },

        initialize: function() {
            this._readOnly = this.model.get("actionIsInUse") || Permissions.Roles.MANAGER.cannot();

            // The EditBehavior uses this.options.isEditable to determine if the title is editable.
            this.options.isEditable = !this._readOnly;
        },

        onRender: function() {
            if (!this._readOnly) {
                this._saveButton = SequentialButton.add(this.ui.saveButton, this._save.bind(this), true, true);
            }
        },

        onShow: function() {
            this._updateErrorAndParameters();

            if (this.model.get("actionIsInUse")) {
                this.lockRegion.show(new CustomJsLockIconView({
                    ids: this.model.get("action").get("usedBy")
                }));
            }
        },

        _textareaChangeHandler: function(event) {
            this._handleSelectionStart(event);
            this._updateErrorAndParameters();
        },

        _saveAction: function() {
            this.ui.cancelButton.addClass("disabled").prop("disabled", true);
            // Activate the action associated with the button, i.e. this._save()).
            this._saveButton();
        },

        _save: function() {
            // Double check that the action isn't used by experiences, contains invalid code, or if
            // there is no code. This should not happen since the save button should be disabled in
            // these cases.
            if (!this.inputValidation()) {
                return SequentialButton.REJECT;
            }

            var code = this.ui.textarea.val();

            this.model.get("action").set({
                name: this.ui.title.text(),
                code: code,
                parameters: helpers.findParameters(code)
            });

            var self = this;
            return this.model.save()
                .done(() => {
                    LoggedInUserState.get("prototypeActionCollection").unshift(self.model);
                    self.trigger("saved");
                    self.closeView();

                    var action = self.model.get("action"),
                        parameters = keys(action.get("parameters")).join(),
                        eventProperties = {
                            category: "Commerce",
                            actionName: action.get("name"),
                            actionParameters: parameters,
                            integrationType: "CustomJS",
                            triggerOrigin: "SaveCustomJSButton"
                        };

                    EditorEvents.trigger(EditorEvents.constants.SAVE_INTEGRATION, eventProperties);
                })
                .fail(() => {
                    if (self.model.get("id")) {
                        // If the save failed and the action has an ID we revert to the previous
                        // version since that will match the version stored in the database.
                        self.model.set(self.model.previousAttributes());
                    }

                    self.ui.cancelButton.removeClass("disabled").prop("disabled", false);
                });
        },

        _updateErrorAndParameters: function() {
            var code        = this._readOnly ? this.ui.textarea.text()
                    : this.ui.textarea.val(),
                parameters  = helpers.findParameters(code),
                error       = CustomJsAction.checkRunnableCode(code, parameters),
                errorText   = error ? CODE_WONT_RUN_MSG + ": " + error : "", // &nbsp; to ensure multiple spaces are respected
                $parameters = [];

            if (!isEmpty(parameters)) {
                each(parameters, (value, name) => {
                    // "checkParameter" returns a possible error, otherwise null on no error...
                    if (!CustomJsAction.checkParameter(name)) { // no value here, only parameter name to validate
                        $parameters.push($("<li>", {text: name}));
                    }
                });
            }

            if (!$parameters.length) {
                $parameters.push($("<li>", {
                    text: "(No parameters)",
                    "class": "no-parameters"
                }));
            }

            this.ui.codeErrorMessage.text(errorText);
            this.ui.parameterList.html($parameters);
        },

        _handleSelectionStart: function(event) {
            var x         = event.clientX, // clientX and -Y are undefined if it's keyboard event.
                y         = event.clientY,
                textarea  = this.ui.textarea[0],
                selection = textarea.selectionEnd > textarea.selectionStart;

            this._togglePlus(selection, x, y);
        },

        _togglePlus: function(selection, x, y) {
            var containerRect,
                textareaRect,
                plusRect,
                css,
                margin = 5;

            if (this._readOnly) {
                return;
            }

            this.ui.plus.toggle(selection);

            if (selection) {
                containerRect = this.el.getBoundingClientRect();
                textareaRect  = this.ui.textarea[0].getBoundingClientRect();
                plusRect      = this.ui.plus[0].getBoundingClientRect();

                if (x && y) {   // Mouseup event
                    css = {
                        left: x - containerRect.left,
                        top: y - containerRect.top
                    };
                } else {        // Keyup event
                    css = {
                        left: textareaRect.right - containerRect.left - plusRect.width - margin,
                        top: textareaRect.top - containerRect.top + margin
                    };
                }

                this.ui.plus.css(css);
            }
        },

        _handlePlusClick: function() {
            var newCode = helpers.addParametersToSelection(this.ui.textarea);

            // Sanity check
            if (this._readOnly) {
                return;
            }

            this.ui.plus.hide();
            this.ui.textarea.val(newCode).trigger("keyup");
            this._updateErrorAndParameters();
        },

        closeView: function() {
            this.trigger("close");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/customJs/editCustomJs/EditCustomJsView.js